var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.667 21.333a2.57 2.57 0 0 1-1.884-.783A2.57 2.57 0 0 1 0 18.667v-16q0-1.1.783-1.884A2.57 2.57 0 0 1 2.667 0H24q1.1 0 1.883.783.784.784.784 1.884v16q0 1.099-.784 1.883a2.57 2.57 0 0 1-1.883.783zM13.333 12 24 5.333V2.667L13.333 9.333 2.667 2.667v2.666z"
})));
export default SvgShareEmail;